/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */

import parse from 'html-react-parser';
import { isMobile } from './Helpers';

const addCommonStyles = (element, id, planName) => {
  const openingLinkData = openingLink(element, id, planName);
  return parse(openingLinkData || '');
};

const openingLink = (htmlAttribute, id, planName) => {
  const title = htmlAttribute?.indexOf('<a');
  if (title > 0) {
    const data = `${htmlAttribute?.slice(0, title + 2)} data-track-detail="${planName}" id=${id} ${htmlAttribute?.slice(title + 2)}`;
    return data;
  }
  return htmlAttribute;
};

export const getBroadBandFacts = (planIds, json, header, buttonGroup, siteName = 'internal') => {
  const broadbandFacts = {
    header: {
      data: {
        title: {
          children: parse(header || ''),
          size: 'titleXLarge',
          primitive: 'h2',
        },
        subtitle: {
          children: 'Prices do not reflect Auto Pay discounts, other discounts or perks.',
          size: 'bodyLarge',
          primitive: 'p',
        },
      },
    },
    ...(buttonGroup && buttonGroup?.data && { buttonGroup: (isMobile() && buttonGroup) || {} }),
    broadbandLabel: [],
  };
  const { broadbandLabel } = broadbandFacts;
  if (planIds && planIds?.length > 0 && siteName === 'internal') {
    planIds.map((planId) => {
      const fccContent = json.plans?.filter((item) => String(item?.planCode) === String(planId));
      broadbandLabel.push(formingJSONStructure(fccContent?.[0]));
    });
  } else {
    json?.plans &&
      json?.plans.map((item) => {
        broadbandLabel.push(formingJSONStructure(item));
      });
  }
  return broadbandFacts;
};

const formingJSONStructure = (json) => {
  if (json) {
    const monthlyPrice = json?.sections?.filter((item) => item.id === 'monthlyPrice');
    const additionalCharges = json?.sections?.filter((item) => item.id === 'additionalCharges');
    const discountsBundles = json?.sections?.filter((item) => item.id === 'discountsBundles');
    const speedList = json?.sections?.filter((item) => item.id === 'speed');
    const speedData = [];
    speedList?.[0]?.data?.map((item) => {
      speedData.push({ ...item, value: parse(item.value || '') });
    });
    const privacyPolicyLink = json?.sections?.filter((item) => item.id === 'privacy');
    const networkManagementLink = json?.sections?.filter((item) => item.id === 'networkManagement');
    // const acpChanges = json?.sections?.filter((item) => item.id === 'acp');
    const dataMonthly = json?.sections?.filter((item) => item.id === 'dataMonthly');
    const customerSupport = json?.sections?.filter((item) => item.id === 'customerSupport');
    return {
      header: parse(`<span id=${json?.planCode}>Broadband Facts</span>` || ''),
      footer: addCommonStyles(json?.footer, `footer-${json?.planCode}`, json?.planName),
      provider: {
        providerName: json?.providerName,
        planName: json?.planName,
        type: json?.type,
        providerNamePrimitive: 'h3',
        planNamePrimitive: 'h3',
      },
      nafSpoId: json?.nafSpoId,
      footnote: json?.planId,
      monthlyPrice: monthlyPrice?.[0],
      additionalCharges: {
        ...additionalCharges?.[0],
        headerPrimitive: 'h3',
        header: parse(`<span className="margin2">${additionalCharges?.[0]?.header}</span>` || ''),
      },
      speedsProvided: {
        ...speedList?.[0],
        headerPrimitive: 'h3',
        data: speedData,
        header: parse(`<span className="margin2">${speedList?.[0]?.header}</span>` || ''),
      },
      discountsAndBundles: {
        ...discountsBundles?.[0],
        header: parse(discountsBundles?.[0]?.header || ''),
        headerPrimitive: 'h3',
        description: addCommonStyles(discountsBundles?.[0]?.description, `discountsBundles-${json?.planCode}`, json?.planName),
      },
      // ACPParticipation: {
      //   ...acpChanges?.[0],
      //   header: parse(acpChanges?.[0]?.header || ''),
      //   headerPrimitive: 'h3',
      //   description: addCommonStyles(acpChanges?.[0]?.description, `acp-${json?.planCode}`, json?.planName),
      // },
      dataIncluded: {
        ...dataMonthly?.[0],
        headerPrimitive: 'h3',
        header: addCommonStyles(`<span className="margin2">${dataMonthly?.[0]?.header}</span>`, `dataMonthly-${json?.planCode}`, json?.planName),
      },
      networkManagementLink: {
        header: parse(`<span className="margin2">${networkManagementLink?.[0]?.header}</span>` || ''),
        ...networkManagementLink?.[0],
        headerPrimitive: 'h3',
        description: addCommonStyles(networkManagementLink?.[0]?.description, `networkManagement-${json?.planCode}`, json?.planName),
      },
      privacyLink: {
        ...privacyPolicyLink?.[0],
        headerPrimitive: 'h3',
        header: parse(`<span className="margin2">${privacyPolicyLink?.[0]?.header}</span>` || ''),
        description: addCommonStyles(privacyPolicyLink?.[0]?.description, `privacy-${json?.planCode}`, json?.planName),
      },
      customerSupport: {
        ...customerSupport?.[0],
        headerPrimitive: 'h3',
        header: parse(customerSupport?.[0]?.header || ''),
        description: addCommonStyles(customerSupport?.[0]?.description, `customerSupport-${json?.planCode}`, json?.planName),
      },
    };
  }
};

export const scrollToPlans = () => {
  const removeFocus = document.getElementById('BacktoTopLink');
  if (removeFocus) {
    removeFocus.blur();
  }
  const elem = document.getElementById('pageHeader');
  if (elem) {
    elem.scrollIntoView({ block: 'center' });
    elem.setAttribute('tabindex', '0');
    elem.focus();
    setTimeout(() => {
      if (elem.getAttribute('tabindex')) {
        elem.addEventListener('keyup', elem.removeAttribute('tabindex'));
      }
    }, 1000);
  }
};

export const scrollToBroadBandFacts = () => {
  const removeFocus = document.getElementById('scrollToBroadBandFacts');
  if (removeFocus) {
    removeFocus.blur();
  }
  const elem = document.getElementById('broadBandFacts');
  if (elem) {
    elem.scrollIntoView();
    elem.setAttribute('tabindex', '0');
    elem.focus();
  }
};

export const planIdMovement = (id, focusElement) => {
  const removeFocus = document.getElementById(focusElement);
  if (removeFocus) {
    removeFocus.blur();
  }

  const elem = document.getElementById(id);
  if (elem) {
    elem.scrollIntoView({ block: 'center' });
  }
};

export const getPlansInfo = (sortedPlanIds, plansInfo, planKey) => {
  const planDetailObject = [];
  sortedPlanIds &&
    sortedPlanIds.map((item) => {
      const planObj = {
        keyName: plansInfo?.[item]?.planDisplayName?.toUpperCase()?.search('PLUS') === -1 ? 'basicPlan' : 'plusPlan',
        planId: item,
        planName: plansInfo?.[item]?.planDisplayName,
      };
      planDetailObject.push(planObj);
    });
  const planIdValue = planDetailObject && planDetailObject.filter((item) => item.keyName === planKey);
  return planIdValue?.[0]?.planId;
};
